export function getHash() {
  return Math.round(Math.random() * 10000000000000)
}

// min and max included
export function randomBetween(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min)
}
